import { getBusAdminList } from '@/api/busAdmin';
import eventBus from '@/utils/eventBus';
import router from '@/router';

const state = {
  menus: [],
  donateImage: '',
  defaultShowTitleList: ['志愿活动', '募捐项目', '机构动态'],
  defaultShowIdList: []
};

const mutations = {
  SET_MENUS: (state, menus) => {
    state.menus = menus;
  },
  SET_DONATE_IMAGE: (state, donateImage) => {
    state.donateImage = donateImage;
  }
};

const actions = {
  generateRoutes({ commit }) {
    return new Promise(async resolve => {
      try {
        // 发起请求获取菜单数据
        const response = await getBusAdminList();
        if (response.success && response.code === 200) {
          const menus = response.data;
          const accessedRoutes = filterAsyncRoutes(menus);
          accessedRoutes.forEach(route => {
            if (route.meta.title === '我要捐赠') {
              commit('SET_DONATE_IMAGE', route.meta.imagePath)
            }
            router.addRoute('Layout', route);
          });
          commit('SET_MENUS', accessedRoutes);
          resolve()
        }
      } catch (error) {
        console.error('获取菜单数据失败:', error);
        return [];
      }
    })
  }
};

// 将菜单配置转换为路由配置
function filterAsyncRoutes(menus, parentNode) {
  const routes = [];
  for (let i = 0; i < menus.length; i++) {
    const menu = menus[i];
    const path = menu.code
    const route = {
      path,
      name: menu.code,
      meta: {
        title: menu.name,
        id: menu.id,
        parentNode: parentNode?.meta,
        dataType: menu.dataType,
        imagePath: menu.imagePath,
        // 递归拼接 fullPath
        fullPath: parentNode ? `${parentNode.meta.fullPath}/${path}` : `/${path}`
      },
      component: (() => {
        if (menu.twoMenuResults && menu.twoMenuResults.length > 0) {
          return () => import('@/components/childRoute.vue')
        } else if (menu.dataType == '0' || menu.dataType == '1') {
          // 文章类
          return () => import('@/components/article.vue')
        } else if (menu.dataType == '2' || menu.dataType == '3') {
          // 监事会、理事会
          return () => import('@/views/peopleList/index.vue')
        } else if (menu.dataType == '4') {
          // 荣誉奖项
          return () => import('@/views/honor/index.vue')
        } else if (menu.dataType == '5') {
          // 志愿活动报名
          return () => import('@/components/registration.vue')
        } else {
          return () => import('@/views/error/ErrorComponent.vue')
        }
      })()
    };
    if (menu.twoMenuResults && menu.twoMenuResults.length > 0) {
      route.children = filterAsyncRoutes(menu.twoMenuResults, route);
      route.redirect = { name: route.children[0].name }
    }
    state.defaultShowTitleList.forEach((title, index) => {
      if (title === menu.name) {
        state.defaultShowIdList[index] = {
          id: menu.id,
          title: menu.name
        }
      }
    })
    if (menu.name === '首页') {
      route.path = '/home'
      route.component = () => import('@/views/home/index.vue');
    }
    routes.push(route);
  }
  return routes;
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
};
